<template>
    <div>
        <v-container>
            <div id="Rate" v-if="step == 1">
                <v-row>
                    <v-col cols="12">
                        <span class="font-b">
                            จากประสบการณ์ของท่านมีความเป็นไปได้มากน้อยเพียงใด
                            ที่ท่านจะแนะนำ HP กับเพื่อนสมาชิกในครอบครัว หรือ
                            ผู้ร่วมงาน
                        </span>
                        <br />
                        <br />
                        <span class="font-b">
                            Based on your experience, how likely would you be to
                            recommend HP to a friend, family member or
                            colleague?
                        </span>
                    </v-col>
                    <v-col cols="12">
                        <img
                            src="../../../assets/all/rate_onsite.jpg"
                            alt="rate onsite"
                            width="100%"
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-slider
                            @change="slider_event()"
                            :color="color[slider]"
                            v-model="slider"
                            thumb-label="always"
                            min="0"
                            max="10"
                            track-color="grey"
                        ></v-slider>
                    </v-col>
                    <v-col cols="12">
                        <v-btn
                            block
                            color="green accent-3"
                            @click="save_rate()"
                            :disabled="chk_slider == false"
                        >
                            Go to next page
                        </v-btn>
                    </v-col>
                </v-row>
            </div>

            <div id="Signature" v-if="step == 2">
                <div class=" mb-5">
                    <v-btn
                        rounded
                        small
                        @click="back()"
                        v-if="show_rate == true"
                    >
                        <v-icon>mdi-chevron-left</v-icon> Back to previous page
                    </v-btn>
                    <v-chip
                        class="ml-2 white--text"
                        :color="color[slider]"
                        v-if="show_rate == true"
                    >
                        Experience Score : {{ slider }}
                    </v-chip>
                </div>
                <VueSignaturePad
                    width="950px"
                    height="250px"
                    ref="signaturePad"
                    :options="{ onBegin, onEnd }"
                    class="bgx no-pd"
                />
                <v-row>
                    <v-col cols="12" class="text-center mt-2">
                        <span class="font-si">
                            E-CSO จะถูกส่งไปยัง E-Mail ที่อยู่ด้านล่างนี้
                            กรุณาตรวจสอบอีกครั้ง
                        </span>
                    </v-col>
                    <v-col cols="12" class="text-center mb-2 mar-t-10">
                        <v-text-field
                            v-model="email"
                            color="info darken"
                            placeholder="Email"
                            outlined
                            dense
                        >
                        </v-text-field>
                    </v-col>
                    <v-col cols="8" class="text-center mar-t-15">
                        <span class="primary--text font-b font-x001">
                            ลูกค้าสามารถ download e-CSO ย้อนหลังได้ที่
                            https://bit.ly/3CGa5t3 หรือ Scan QR Code
                        </span>
                    </v-col>
                    <v-col cols="4" class="mar-t-15">
                        <img src="../../../assets/all/qrcode.png" width="80%" />
                    </v-col>
                    <v-col cols="6">
                        <v-btn @click="undo" block color="amber lighten-2">
                            <v-icon class="mr-1">mdi-undo-variant</v-icon>
                            Undo
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn
                            :disabled="chk_isEmpty == true"
                            @click="save_sign()"
                            block
                            color="green accent-3"
                        >
                            <v-icon class="mr-1">mdi-content-save</v-icon>
                            Save
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-container>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"
let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    props: ["data_sign", "show_rate", "show_sign", "e_email", "pages"],
    watch: {
        data_sign: function(newQuestion, oldQuestion) {
            this.d_pages = this.pages
            this.email = this.e_email
            this.slider = 0
            this.show_rate == false ? (this.step = 2) : (this.step = 1)
        },
    },
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        // console.log(this.show_rate, "--show_rate")
        // console.log(this.show_sign, "--show_sign")
        this.d_pages = this.pages
        this.email = this.e_email
        this.show_rate == false ? (this.step = 2) : (this.step = 1)
    },
    methods: {
        onBegin() {
            this.$refs.signaturePad.resizeCanvas()

            // console.log("=== Begin ===")
        },
        onEnd() {
            const { isEmpty } = this.$refs.signaturePad.saveSignature()
            this.chk_isEmpty = isEmpty
            // console.log("=== End ===")
        },
        undo() {
            this.$refs.signaturePad.undoSignature()
            const { isEmpty } = this.$refs.signaturePad.saveSignature()
            this.chk_isEmpty = isEmpty
            // console.log(data, "-data")
        },
        async save_sign() {
            this.dialog_loading = true
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature()
            // console.log(isEmpty, "-isEmpty")
            // console.log(data, "-data")

            let formData = new FormData()
            formData.append("subcase_id", this.data_sign)
            formData.append("rate", this.slider)
            formData.append("sign", data)
            formData.append("email", this.email)

            await axios
                .post(url + "engineer/save-customer", formData, this.tk)
                .then((response) => {
                    if (this.d_pages == "onsite") {
                        this.dialog_loading = false
                        this.getPage(response.data.show_ismart)
                    } else {
                        this.$emit("page_ismart_perf")
                    }
                })
                .catch(function(error) {
                    this.dialog_loading = false
                    this.$swal({
                        title: this.show_title_case_id,
                        text: "ปิดงานไม่สำเร็จ รบกวนติดต่อ Programmer Team !",
                        icon: "warning",
                        button: true,
                    })
                })
        },
        getPage(result) {
            this.$emit("page_ismart", result)
        },
        save_rate() {
            this.step = 2
        },
        back() {
            this.step = 1
        },
        slider_event() {
            this.chk_slider = true
        },
    },
    data() {
        return {
            email: "",
            step: 1,
            slider: 0,
            color: [
                "red",
                "red",
                "red",
                "red",
                "red",
                "red",
                "red",
                "yellow lighten-1",
                "yellow lighten-1",
                "success",
                "blue darken-4",
            ],
            chk_slider: false,
            tk: null,
            dialog_loading: false,
            d_pages: "",
            chk_isEmpty: true,
        }
    },
}
</script>
<style scoped>
.bgx {
    background-color: rgb(209, 233, 236) !important;
}
.font-si {
    font-size: 14px;
    font-weight: bold;
    color: rgb(44, 74, 129);
}
.font-x001 {
    font-size: 16px;
}
</style>
